import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/toughpaper/web/components/BreadCrum.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/toughpaper/web/node_modules/next/dist/client/app-dir/link.js");
